import {BreadCrumbs} from "../../../components/open/pages";
import {
    CheckIcon,
    ThinAdvertisingIcon,
    ThinArrowLeft,
    ThinChevronRight,
    ThinCloseIcon,
    ThinCreditScoreIcon,
    ThinShoppingCartIcon,
    ThinStoreIcon,
    ThinSupportIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {Link, useNavigate} from "react-router-dom";
import '../../../static/css/pages/parents/dashboard/dashboard.css';
import {useEffect, useState} from "react";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {GradeToString} from "../../admins/students/list";
import {PayTuitionModal} from "../tuition/pay-tuition";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {ParentsChooseExtraPriceModal} from "../extra/choose-extra-price-modal";

interface extraPaymentInterface {
    nd: string,
    title: string,
    price: number,
    expiresAt: string,
    optional: 0 | 1,
}

export const StudentsOverviewScreen = () => {
    const [data, setData] = useState({
        loaded: false,
        firstName: '',
        lastName: '',
        tuitionMode: 'dept' as 'dept' | 'upfront' | 'free',
        tuitionPrice: 0,
        tuitionPaidCount: 0,
        isInside: false,
        newsCount: 0,
        ticketsOpen: 0,
        budget: 0,
        grade: 0,
        className: '',
        amountPaid: 0,
        percentPaid: 0,
        lastEntrance: {
            isEntrance: false,
            createdAt: '2000-01-01 00:00:00',
            hasAttendLog: false,
        },
        minTuitionPay: 0,
        isTuitionSet: false,
        offAmount: 0,
        extraProgramCost: 0,
        extraPayments: [] as extraPaymentInterface[],
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/parents/dashboard/overview',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                budget: number,
                tuitionMode: "dept" | 'upfront' | 'free',
                totalPrice: number,
                isInside: 0 | 1,
                firstName: string,
                lastName: string,
                news: number,
                ticketsOpen: number,
                paidCount: number,
                amountPaid: number,
                lastIsEntrance: 0 | 1,
                lastCreatedAt: string,
                hasAttendLog: boolean,
                class: string,
                grade: number,
                min: number,
                offAmount: number,
                extraProgramCost: number,
                extraPayments: extraPaymentInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setData({
                    loaded: true,
                    firstName: d.firstName,
                    lastName: d.lastName,
                    tuitionMode: d.tuitionMode,
                    tuitionPrice: d.totalPrice,
                    tuitionPaidCount: d.paidCount,
                    isInside: d.isInside === 1,
                    newsCount: d.news,
                    ticketsOpen: d.ticketsOpen,
                    budget: d.budget,
                    amountPaid: d.amountPaid,
                    percentPaid: (d.amountPaid * 100) / d.totalPrice,
                    lastEntrance: {
                        isEntrance: d.lastIsEntrance === 1,
                        createdAt: d.lastCreatedAt,
                        hasAttendLog: d.hasAttendLog,
                    },
                    grade: d.grade,
                    className: d.class,
                    minTuitionPay: d.min,
                    isTuitionSet: d.totalPrice !== -1,
                    offAmount: d.offAmount,
                    extraProgramCost: d.extraProgramCost,
                    extraPayments: d.extraPayments === null ? [] : d.extraPayments,
                });
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "داشبورد | نهال";
        fetchData();
    }, []);
    const [payModal, setPayModal] = useState(false);
    const navigate = useNavigate();
    const generateInvoiceForExtra = (paymentNd: string) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/extra/issue',
            {
                nd: paymentNd,
            },
            true,
            (d: {
                result: string,
                reason: string,
                nd: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                ShowSnackbar(
                    'می‌توانید فاکتور ایجاد شده را پرداخت نمایید.',
                    'باشه',
                    5000,
                );
                navigate(`/students/extra/invoice/${d.nd}`);
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    const [extraModal, setExtraModal] = useState({
        show: false,
        nd: '',
        title: '',
    });
    return (
        <>
            <BreadCrumbs links={[{title: 'داشبورد', url: `/students/overview`}]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration="1000">
                        <div className="student-welcome">
                            <b>سلام، {data.firstName + " " + data.lastName}!</b>
                            <span>دانش آموز پایه {GradeToString(data.grade) + " کلاس " + data.className}</span>
                        </div>
                        <div className="page-top-warning d-none">
                            <span>شما یک قسط شهریه پرداخت نشده دارید، هم اکنون اقدام کنید.</span>
                            <Link to={"/students/tuition"}>
                                <span>پرداخت</span>
                                <ThinChevronRight/>
                            </Link>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-md-4">
                                <Link to={`/students/tuition`} className="students--dashboard-cards"
                                      data-color="blue">
                                    <em><ThinCreditScoreIcon/></em>
                                    <div>
                                        <b>{CurrencyFormat(data.tuitionPaidCount)}</b>
                                        <span>اقساط شهریه پرداخت شده</span>
                                        {
                                            data.isTuitionSet ?
                                                <>
                                                    <strong>
                                                        {CurrencyFormat(data.tuitionPrice - data.amountPaid)} تومان
                                                        باقی‌مانده است.
                                                    </strong>
                                                    <i><em style={{width: `${data.percentPaid}%`}}/></i>
                                                </> : null
                                        }
                                    </div>
                                    {
                                        !data.isTuitionSet ?
                                            <small><ThinArrowLeft/></small> : null
                                    }
                                </Link>
                            </div>
                            <div className="col-lg-3 col-md-4">
                                <Link to={`/students/store`} className="students--dashboard-cards"
                                      data-color="blue">
                                    <em><ThinStoreIcon/></em>
                                    <div>
                                        <b>{CurrencyFormat(data.budget)} <TomansIcon/></b>
                                        <span>موجودی فروشگاه</span>
                                    </div>
                                    <small><ThinArrowLeft/></small>
                                </Link>
                            </div>
                            <div className="col-lg-3 col-md-4">
                                <Link to={`/students/news`} className="students--dashboard-cards"
                                      data-color="blue">
                                    <em><ThinAdvertisingIcon/></em>
                                    <div>
                                        <b>{CurrencyFormat(data.newsCount)}</b>
                                        <span>اطلاعیه جدید</span>
                                    </div>
                                    <small><ThinArrowLeft/></small>
                                </Link>
                            </div>
                            <div className="col-lg-3 col-md-4">
                                <Link to={`/students/tickets`} className="students--dashboard-cards"
                                      data-color="blue">
                                    <em><ThinSupportIcon/></em>
                                    <div>
                                        <b>{CurrencyFormat(data.ticketsOpen)}</b>
                                        <span>تیکت پشتیبانی باز</span>
                                    </div>
                                    <small><ThinArrowLeft/></small>
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            {
                                data.extraPayments.length > 0 ?
                                    <div className="col-lg-12">
                                        <div className="screen-card" style={{marginBottom: 0}}>
                                            <div className="screen-card-header">
                                                <b>موارد قابل خرید</b>
                                            </div>
                                            {
                                                data.extraPayments.map((p, i) =>
                                                    <button className="extra-payment-item"
                                                            onClick={() => {
                                                                if (p.optional === 1)
                                                                    setExtraModal({
                                                                        title: p.title,
                                                                        show: true,
                                                                        nd: p.nd,
                                                                    });
                                                                else
                                                                    generateInvoiceForExtra(p.nd);
                                                            }}
                                                            key={"AAjm39fjFfjd39i" + i}>
                                                        <div>
                                                            <i><ThinShoppingCartIcon/></i>
                                                            <div>
                                                                <b>{p.title}</b>
                                                                {
                                                                    p.optional === 1 ?
                                                                        null :
                                                                        <span>{CurrencyFormat(p.price)}<TomansIcon/></span>
                                                                }
                                                            </div>
                                                        </div>
                                                        <em>
                                                            پرداخت
                                                            <ThinChevronRight/>
                                                        </em>
                                                    </button>
                                                )
                                            }
                                        </div>
                                    </div> : null
                            }
                            <div className="col-lg-4">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>وضعیت حضورغیاب</b>
                                    </div>
                                    {
                                        data.lastEntrance.hasAttendLog && data.isInside ?
                                            <div className="student-attend-ok">
                                                <i><CheckIcon/></i>
                                                <b>حاضر در مدرسه</b>
                                                {
                                                    data.lastEntrance.isEntrance === data.isInside ?
                                                        <span>آخرین ورود: {StringDigitsConvertToPersian(data.lastEntrance.createdAt.split(' ')[1]) + " " + StringDigitsConvertToPersian(GregorianToPersian(data.lastEntrance.createdAt.split(' ')[0]).replaceAll('-', '/'))}</span> : null
                                                }
                                            </div> :
                                            <div className="student-attend-err">
                                                <i><ThinCloseIcon/></i>
                                                <b>عدم حضور</b>
                                                {
                                                    data.lastEntrance.hasAttendLog && data.lastEntrance.isEntrance === data.isInside ?
                                                        <span>آخرین خروج: {StringDigitsConvertToPersian(data.lastEntrance.createdAt.split(' ')[1]) + " " + StringDigitsConvertToPersian(GregorianToPersian(data.lastEntrance.createdAt.split(' ')[0]).replaceAll('-', '/'))}</span> : null
                                                }
                                            </div>
                                    }
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>وضعیت شهریه</b>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-4">
                                            <div className="tuition-status">
                                                <span>نوع پرداخت</span>
                                                <b>{!data.isTuitionSet ? 'نامشخص' : (data.percentPaid === 100 || data.tuitionPrice === 0 ? 'تکمیل شده' : 'بدهکار')}</b>
                                                <strong>{CurrencyFormat(data.percentPaid.toFixed(0))}٪
                                                    پرداخت
                                                    شده</strong>
                                                <div className="progress">
                                                    <div
                                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                                        style={{width: `${data.percentPaid}%`}}/>
                                                </div>
                                                {data.extraProgramCost > 0 ? <em>دارای فوق برنامه
                                                    ({CurrencyFormat(data.extraProgramCost)} تومان)</em> : null}
                                                {data.offAmount > 0 ?
                                                    <em> {CurrencyFormat(data.offAmount)} تومان تخفیف اعمال شده
                                                        است.</em> : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="tuition-status">
                                                <span>پرداخت شده</span>
                                                <p style={{color: 'darkgreen'}}>{CurrencyFormat(data.amountPaid)}
                                                    <TomansIcon/></p>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="tuition-status">
                                                <span>بدهکاری</span>
                                                <p style={{color: '#8b0000'}}>{!data.isTuitionSet ? '۰' : CurrencyFormat(data.tuitionPrice - data.amountPaid)}
                                                    <TomansIcon/></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-center"
                                         style={{gap: 10, marginTop: 15}}>
                                        <Link to="/students/tuition" className="cancel-button">
                                            <b>مشاهده بیشتر</b>
                                        </Link>
                                        {
                                            data.isTuitionSet ?
                                                <button className="btn-pay" onClick={() => setPayModal(true)}>
                                                    <b>پرداخت قسط</b>
                                                    <ThinArrowLeft/>
                                                </button> : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
            <PayTuitionModal
                active={payModal}
                closeHandler={() => setPayModal(false)}
                totalPrice={data.tuitionPrice}
                paidSoFar={data.amountPaid}
                suggestedPrice={data.minTuitionPay}
                min={data.minTuitionPay}
            />
            <ParentsChooseExtraPriceModal
                active={extraModal.show}
                closeHandler={() => setExtraModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={extraModal.title}
                paymentNd={extraModal.nd}
            />
        </>
    );
};